import * as supplierAction from "../../../../../../actions/supplierAction";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import ListSupplier from "./ListSupplier";

const mapStateToProps = state => {
    return {
        supplierState: state.supplierReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListProductBySupplier: (params) => dispatch(supplierAction.getSupplierProducts(params)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ListSupplier));
